import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class GameMpProvider {
  public static async exit(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.QuitGameResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      undefined,
      typeof RegionShared.Responses.GameQuitResponse
    >(RegionShared.Client.Events.Game.QuitGame, undefined);
  }

  public static async onMouseEnterBrowserContainer(
    data: typeof RegionShared.Client.Requests.OnMouseLeaveBrowserRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.OnMouseEnterBrowserContainerResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.OnMouseEnterBrowserContainerRequest,
      typeof RegionShared.Client.Responses.OnMouseEnterBrowserContainerResponse
    >(RegionShared.Client.Events.Game.OnMouseEnterBrowserContainer, data);
  }

  public static async onMouseLeaveBrowserContainer(
    data: typeof RegionShared.Client.Requests.OnMouseLeaveBrowserRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.OnMouseLeaveBrowserResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.OnMouseLeaveBrowserRequest,
      typeof RegionShared.Client.Responses.OnMouseLeaveBrowserResponse
    >(RegionShared.Client.Events.Game.OnMouseLeaveBrowserContainer, data);
  }

  public static async closeCurrentInterface(
    isForced: boolean = false,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.CloseCurrentInterfaceResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.CloseCurrentInterfaceRequest,
      typeof RegionShared.Client.Responses.CloseCurrentInterfaceResponse
    >(RegionShared.Client.Events.Game.CloseCurrentInterface, {
      isForced,
    });
  }
}
